module.exports = __webpack_public_path__ + "img/email_sent.921f76cf.png";